<form [formGroup]="filterForm" class="top-actions">
  <mat-form-field *ngIf="isInternalUser" appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'customer-spaces.customer-space-list.title' | translate }}</mat-label>
    <mat-select formControlName="customerSpaceSelect">
      <mat-option *ngFor="let selection of customerSpaceSelections()" [value]="selection">
        {{ customerSpaceSelectionTypeTranslationKeyMapping[selection] | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'shared.search' | translate }}</mat-label>
    <input matInput formControlName="search" autocomplete="not" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</form>

<div class="app-table-container">
  <table mat-table matSort [dataSource]="dataSource" class="app-table app-table-hoverable">
    <!-- Favorite Column -->
    <ng-container matColumnDef="favorite">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [color]="element.isFavorite ? 'primary' : 'accent'" (click)="toggleFavorite(element)"
          [matTooltip]="
            (element.isFavorite
              ? 'customer-spaces.customer-space-list.favorites.active'
              : 'customer-spaces.customer-space-list.favorites.inactive'
            ) | translate
          " matTooltipPosition="after" [attr.aria-label]="
            (element.isFavorite
              ? 'customer-spaces.customer-space-list.favorites.active'
              : 'customer-spaces.customer-space-list.favorites.inactive'
            ) | translate
          ">
          <mat-icon [svgIcon]="element.isFavorite ? 'favorite_filled' : 'favorite_outlined'" />
        </button>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'customer-spaces.name' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="isMyCustomerSpace(element)" [routerLink]="['/', 'customer-spaces', element.id, 'cockpit']"
          class="cell-link">
          {{ element.name }}
        </a>
        <span *ngIf="!isMyCustomerSpace(element)">{{ element.name }}</span>
      </td>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <a *appShowAuthorize="'CUSTOMER_SPACE_WRITE'; options: { values: { customerSpaceId: element.id } }"
          mat-icon-button [routerLink]="['/', 'customer-spaces', element.id, 'admin']"
          [matTooltip]="'shared.edit' | translate" matTooltipPosition="after">
          <mat-icon svgIcon="edit_icon" />
        </a>
      </td>
    </ng-container>

    <!-- Tasks Column -->
    <ng-container matColumnDef="tasks">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><mat-icon svgIcon="task" class="header-icon" /></th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="isMyCustomerSpace(element)" mat-icon-button
          [routerLink]="['/', 'customer-spaces', element.id, 'fiduciary', 'tasks']"
          [matTooltip]="'shared.tasks' | translate" matTooltipPosition="after">
          <mat-icon [matBadge]="element.openTaskCount" matBadgeSize="small"
            [matBadgeHidden]="element.openTaskCount <= 0" svgIcon="task" aria-hidden="false" />
        </a>
      </td>
    </ng-container>

    <!-- Notifications Column -->
    <ng-container matColumnDef="notifications">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><mat-icon svgIcon="notifications_icon"
          class="header-icon" /></th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="isMyCustomerSpace(element)" mat-icon-button
          [routerLink]="['/', 'customer-spaces', element.id, 'cockpit']" [queryParams]="{ showNotifications: true }"
          [matTooltip]="'shared.notifications' | translate" matTooltipPosition="after">
          <mat-icon [matBadge]="element.notificationCount" matBadgeSize="small"
            [matBadgeHidden]="element.notificationCount <= 0" svgIcon="notifications_icon" aria-hidden="false" />
        </a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['favorite', 'name', 'edit', 'tasks', 'notifications']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['favorite', 'name', 'edit', 'tasks', 'notifications']"></tr>
  </table>
</div>

<app-empty-list *ngIf="dataSource.filteredData.length === 0"
  [text]="'customer-spaces.customer-space-list.empty-list' | translate" />

<mat-paginator [pageSizeOptions]="[50, 100, 500, 1000, 5000]" />
<div class="bottom-actions">
  <a *appShowAuthorize="'CUSTOMER_SPACE_CREATE'" mat-stroked-button color="primary"
    [routerLink]="['/customer-spaces', 'create']">
    <mat-icon svgIcon="add_icon" />
    {{ 'customer-spaces.customer-space-list.actions.create-customer-space' | translate }}
  </a>
</div>